import { render, staticRenderFns } from "./batchFirstClaimDialog.vue?vue&type=template&id=eefa0f5e&scoped=true"
import script from "./batchFirstClaimDialog.vue?vue&type=script&lang=js"
export * from "./batchFirstClaimDialog.vue?vue&type=script&lang=js"
import style0 from "./batchFirstClaimDialog.vue?vue&type=style&index=0&id=eefa0f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefa0f5e",
  null
  
)

export default component.exports